<template>
  <div class="save-checklist-dialog-share-type">
    <v-radio-group
      v-model="shareType"
      hide-details
      class="share-type-container"
      :class="containerClasses"
      required
      inline
    >
      <div v-for="option in shareTypeOptionsValues"
            :key="`option-${option}`"
            class="d-flex flex-column"
      >
        <v-radio :value="option"
                  class="share-type-card mb-2"
                 :class="{ 'share-type-card--active': option === shareType }"
                 @click.stop="handleCardClick"
        >
          <template v-slot:label>
            <h4>
              <template v-if="withoutPrivateOption">
                {{ $t(`project.checklist.dialogs.ImportChecklistDialog.accessRights.shareTypeOptions.${option}`) }}
              </template>
              <template v-else>
                {{ $t(`project.checklist.dialogs.SaveChecklistDialog.sharingOptions.shareTypeOptions.${option}`) }}
              </template>
            </h4>
          </template>
        </v-radio>
      </div>
    </v-radio-group>
  </div>
</template>

<script>
  import { SHARE_TYPE_OPTIONS } from '@/common/utils/shareTypes.ts'

  export default {
    name: 'SaveChecklistDialogShareType',
    props: {
      defaultShareType: {
        type: String,
        required: true,
      },
      withoutPrivateOption: {
        type: Boolean,
        default: false,
      },
      withoutPublicOption: {
        type: Boolean,
        default: false,
      },
    },
    data () {
      return {
        shareType: this.defaultShareType,
      }
    },
    computed: {
      shareTypeOptionsValues () {
        let values = Object.values(SHARE_TYPE_OPTIONS)
        if (this.withoutPrivateOption) {
          values = values.filter(item => item !== SHARE_TYPE_OPTIONS.PRIVATE)
        }
        if (this.withoutPublicOption) {
          values = values.filter(item => item !== SHARE_TYPE_OPTIONS.PUBLIC)
        }
        return values
      },
      containerClasses () {
        return {
          'share-type-container-col-2': this.withoutPrivateOption,
          'share-type-container-col-3': !this.withoutPrivateOption,
        }
      },
    },
    watch: {
      shareType (value) {
        this.$emit('change-share-type', value)
      },
    },
    methods: {
      handleCardClick (originalEvent) {
        const innerInput = originalEvent.target.querySelector('input')
        if (innerInput) {
          // Indeed, in Vuetify 3 the event is now on the input and label... Not on the radio anymore.
          // So, since the styling is on the radio, we just make it click its inner input to get the associated logic.
          originalEvent.target.querySelector('input').click()
        }
      },
    },
  }
</script>

<style lang="scss">
@import "vuetify/settings";

.save-checklist-dialog-share-type {
  .share-type-container {
    margin-top: $spacer * 4;
    margin-bottom: 0;

    .v-selection-control-group {
      display: grid;
      gap: 16px;
      grid-template-columns: repeat(1, 1fr);
      width: 100%;
    }

    .share-type-card {
      border: 1px solid #DEE2E6;
      border-radius: 4px;
      margin: 0;
      padding: 4px;

      &--active {
        outline: 2px solid rgb(var(--v-theme-primary));
        outline-offset: -2px;
        background-color: rgb(var(--v-theme-primary-lighten-4));
      }

      .caption {
        color: #717B85;
        font-size: 12px;
      }
    }
  }

  .share-type-container-col-2 {
    @media screen and (min-width: 1024px) {
      .v-selection-control-group {
        grid-template-columns: repeat(2, 1fr);
      }
    }
  }

  .share-type-container-col-3 {
    @media screen and (max-width: 1023px) and (min-width: 768px) {
      .v-selection-control-group {
        grid-template-columns: repeat(2, 1fr);
      }
    }
    @media screen and (min-width: 1024px) {
      .v-selection-control-group {
        grid-template-columns: repeat(3, 1fr);
      }
    }
  }
}
</style>
